export default "__VITE_ASSET__CBRYoTGP__"